import React from 'react';
import PropTypes from 'prop-types';

import CallToActionComponent from '../../components/Elements/CallToActionComponent/CallToActionComponent';
import ShareIconSection from '../../components/Elements/ShareIconSection/ShareIconSection';
import PostNow from '../../components/Wrappers/PostNow/PostNow';

const Sidebar = ({ topics, meta }) => (
    <div>
        <PostNow
            topics={topics}
            message={
                <div>
                    <div className="say-something p-2">
                        Have something to say?
                    </div>
                </div>
            }
        />
        <CallToActionComponent orientation="portrait" />
        <ShareIconSection meta={meta} />
    </div>
);

export default Sidebar;

const MetaSocialPropType = PropTypes.shape({
    appId: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
    text: PropTypes.string,
});

const MetaPropType = PropTypes.shape({
    description: PropTypes.string,
    hostUrl: PropTypes.string,
    keywords: PropTypes.string,
    social: PropTypes.shape({
        twitter: MetaSocialPropType,
        facebook: MetaSocialPropType,
    }),
    title: PropTypes.string,
});

const TopicPropType = PropTypes.shape({
    isDefault: PropTypes.number,
    layout: PropTypes.string,
    qaDataAttr: PropTypes.string,
    // TODO flesh out data shape for "sponsored"
    sponsored: PropTypes.object, // eslint-disable-line
    title: PropTypes.string,
    total: PropTypes.number,
    url: PropTypes.string,
});

Sidebar.propTypes = {
    meta: MetaPropType,
    topics: PropTypes.arrayOf(TopicPropType),
};

Sidebar.defaultProps = {
    meta: { social: { twitter: {}, facebook: {} } },
    topics: [],
};
